export const trimId = (id: string, replaceWith = ''): string => {
  return id.replace('gid://shopify/Customer/', replaceWith);
};
